import { set } from "firebase/database";
import _ from "lodash";
import dataservice from "../../core/services/dataservice";
import { useShopStore } from "../../core/store/shop";
import { SETTING_ID } from "~/interface/Setting";

export const useSettingsStore = defineStore("settings", {
  state: () => ({
    settings: null as any,
    isLoading: false,
  }),
  getters: {
    getValueBysettingId(state) {
      return (settingId: string, defaultValue: any) => {
        let data = state.settings?.find((x: any) => x.settingId === settingId);
        if (data) {
          return data.value;
        } else {
          return defaultValue;
        }
      };
    },
    getBysettingId(state) {
      return (settingId: string, defaultValue: any) => {
        let data = state.settings?.find((x: any) => x.settingId === settingId);
        if (data) {
          return data;
        } else {
          return defaultValue;
        }
      };
    },
    getStoreName(state) {
      let data = state.settings?.find((x: any) => x.settingId === "name");
      if (data) {
        return data.value;
      } else {
        return "No Name";
      }
    },
    getRoundingType(state){
      let data = state.settings?.find((x: any) => x.settingId === SETTING_ID.ROUNDING);
      return data?.value || SETTING_ID.ROUNDING_OPTION_NEAREST
    },
    getPosUiMode(state){
      let data = state.settings?.find((x: any) => x.settingId === SETTING_ID.POS_UI_MODE);
      return data?.value || SETTING_ID.POS_UI_MODE_EASY
    },
    isPosEasyMode(): boolean {
      return   this.getPosUiMode === SETTING_ID.POS_UI_MODE_EASY
    },
    qrMenuList(state) {
      // return (ts) => {
      if (!state.settings) {
        return [];
      }
      let qrMenuList = state.settings?.filter((x: any) => {
        return x?.settingId?.startsWith("qrcode_menu_");
      });
      if (qrMenuList) {
        return qrMenuList?.filter((x: any) => x.active == true);
      } else {
        return [];
      }
      //  }
    },
    findMenuSetting(state) {
      return (menuId) => {
        return _.find(state.settings, { settingId : menuId });
      }
    },
    getRooms(state) {
      let data = state.settings?.find((x: any) => x.settingId === "roomCharge");
      if (data) {
        return data?.value || [];
      } else {
        return [];
      }
    },
  },
  actions: {
    async main() {
      await this.fetch();
      await this.migrateShowBeforeVat();
    },

    /**
     * ก่อนจะมี setting show_before_vat ใบเสร็จพิมพ์บรรทัด "Before VAT" ให้ทุกร้านที่คิด VAT อยู่แล้ว
     * ร้านเดิมจึงควรได้ค่า true ติดตัวไว้เป็นลายลักษณ์อักษร ไม่ใช่พึ่ง default อย่างเดียว
     * เผื่อวันหลังเปลี่ยน default เป็น false ใบเสร็จของร้านเดิมจะได้ไม่หายไปเงียบ ๆ
     *
     * เขียนครั้งเดียว: ถ้ามี record อยู่แล้วไม่ว่าค่าจะเป็นอะไร (รวมถึงร้านที่ตั้งใจปิด) จะไม่ยุ่งอีก
     */
    async migrateShowBeforeVat() {
      const existing = this.getBysettingId(SETTING_ID.SHOW_BEFORE_VAT, null);
      if (existing) return;

      // 1 = VAT included, 2 = VAT excluded — ร้านที่ไม่คิด VAT ไม่เคยเห็นบรรทัดนี้อยู่แล้ว ไม่ต้องเขียน
      const taxMode = parseInt(
        this.getValueBysettingId(SETTING_ID.TAX_MODE, 0)
      );
      if (taxMode !== 1 && taxMode !== 2) return;

      try {
        await this.insert({
          settingId: SETTING_ID.SHOW_BEFORE_VAT,
          value: true,
        });
      } catch (error) {
        // เขียนไม่ผ่านไม่ใช่เรื่องคอขาดบาดตาย default เป็น true อยู่แล้ว ไว้ลองใหม่ตอน boot รอบหน้า
        console.warn("[settings] migrate show_before_vat ไม่สำเร็จ", error);
      }
    },
    async fetch() {
      this.isLoading = true;

      let res = await dataservice.settings.getAll();

      this.settings = res.data;
      // this.settings.push({
      //   createdAt: "2025-07-14T11:20:32.941Z",
      //   settingId: "max_printer",
      //   storeId: "demo01",
      //   value: 10
      // });      

     

      this.isLoading = false;

      return res.data;
    },
    async insert(data: any) {
      let res = await dataservice.settings.post(data);
      await useDelaySecs(1)
      await this.fetch();
      await this.syncToFirebase(
        data.settingId === SETTING_ID.SHOP_NAME ? data.value : undefined
      );
      return res;
    },
    async update(data: any) {
      // use POST for update to overwrite the whole object
      let res = await dataservice.settings.post(data);
      await useDelaySecs(1)
      
      await this.fetch();
      await this.syncToFirebase(
        data.settingId === SETTING_ID.SHOP_NAME ? data.value : undefined
      );
      return res;
    },
    async updatePartial(data: any) {
      let res = await dataservice.settings.update(data);
      await useDelaySecs(1)
      await this.fetch();
      await this.syncToFirebase(
        data.settingId === SETTING_ID.SHOP_NAME ? data.value : undefined
      );
      return res
    },
    async delete(setting: any) {
      // await axios
      //   .delete(this.apiUrl, setting)
      //   .then((response) => response)
      //   .catch((err) => console.error(err));
    },

    syncToFirebase(latestShopName?: string) {
      let settings = this.settings;
      let settingsRef = useFirebase().settingsRef();
      let shopStore = useShopStore();

      let paylaod = _.keyBy(settings, "settingId");

      set(settingsRef, settings);

      
      let shopNameRef = useFirebase().shopNameRef();
      let _name = latestShopName || shopStore.name || this.getStoreName;
      set(shopNameRef, _name);
    },
  },
});
